module.exports = __webpack_public_path__ + "static/media/Niveau_elN4_2_779206.92838ff4.png";